import React, { useEffect } from "react";
import { EditOutlined } from "@ant-design/icons";
import { Form, Input, Select, Button } from "antd";
import TextArea from "antd/es/input/TextArea";
import ButtonWrapper from "../../components/reuseComp/ButtonWrapper";
import { IBlogListPayload } from "../../../types/api/blog"
import { useListBlog } from "../../../hooks/api/blog/hook"

const GreenJournal: React.FC<{
  isEditing: boolean;
  setIsEditing: (value: boolean) => void;
  handleCancel: () => void;
  handleSave: () => void;
  form: any;
  greenJournalData?: {
    heading?: string;
    subtext?: string;
    selectedBlog?: string[];
    isHidden?: boolean;
  };
  loading?: boolean;
}> = ({
  isEditing,
  setIsEditing,
  handleCancel,
  handleSave,
  form,
  loading,
  greenJournalData,
}) => {
  useEffect(() => {
    if (greenJournalData) {
      form.setFieldsValue({
        green_journal: {
          heading: greenJournalData.heading || "",
          subtext: greenJournalData.subtext || "",
          selectedBlog:
          greenJournalData.selectedBlog?.map((b: any) => b._id) || [],
        },
      });
    } else {
      form.resetFields();
    }
  }, [greenJournalData, form]);

  const { data } = useListBlog({ page: 1, limit: 20, isAll: true });
  const blogList: IBlogListPayload[] = data?.data || [];
  const selectedBlog =
    Form.useWatch(["green_journal", "selectedBlog"], form) || [];

  return (
    <div>
      {!isEditing ? (
        <>
          {/* Desktop View */}
          <div className="rounded-[20px] overflow-hidden">
            <table className="overflow-x-auto hidden min-w-full sm:table">
              <thead>
                <tr className="bg-primary text-white">
                  <th className="py-3 px-4 text-left">Heading</th>
                  <th className="py-3 px-4 text-left">Subtext</th>
                  <th className="py-3 px-4 text-right">Action</th>
                </tr>
              </thead>
              <tbody>
                {greenJournalData ? (
                  <tr className="bg-[#F9F9F9] border-b border-[#e9e8e8]">
                    <td className="py-3 px-4">
                      {greenJournalData.heading}
                    </td>
                    <td className="py-3 px-4">
                      {greenJournalData.subtext}
                    </td>
                    <td className="py-3 px-4  text-primary">
                      <div className="flex items-center gap-4 justify-end">
                        <EditOutlined
                          onClick={() => setIsEditing(true)}
                          className="cursor-pointer hover:text-blue-600 text-[20px]"
                        />
                      </div>
                    </td>
                  </tr>
                ) : (
                  <tr>
                    <td colSpan={3} className="text-center py-6 text-gray-500">
                      <Button type="dashed" onClick={() => setIsEditing(true)}>
                        Add data
                      </Button>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            <div className="bg-[#F9F9F9] border-b border-[#e9e8e8] sm:block hidden">
              <div className="py-3 px-4">
                <Form layout="vertical" form={form}>
                  <Form.Item
                    label="Select Blogs"
                    name={["green_journal", "selectedBlog"]}
                  >
                    <Select
                      mode="multiple"
                      placeholder="Select Blogs"
                      className="w-full"
                      showSearch
                      optionFilterProp="label"
                      options={blogList.map((blog) => ({
                        label: blog.heading,
                        value: blog._id,
                      }))}
                    />
                  </Form.Item>
                </Form>

                <ButtonWrapper
                  type="primary"
                  onClick={handleSave}
                  loading={loading}
                >
                  Save
                </ButtonWrapper>
              </div>
            </div>
          </div>

          <table className="min-w-full table sm:hidden">
            <tbody>
              {greenJournalData ? (
                <tr className="bg-[#F9F9F9] border block mb-4 rounded-lg shadow-sm">
                  <td className="py-3 px-4 block">
                    <span className="font-semibold text-primary block mb-1">
                      Heading:
                    </span>
                    {greenJournalData.heading}
                  </td>
                  <td className="py-3 px-4 block">
                    <span className="font-semibold text-primary block mb-1">
                      Subtext:
                    </span>
                    {greenJournalData.subtext}
                  </td>

                  <td className="py-3 px-4 text-primary block text-left">
                    <div>
                                      <span className="font-semibold text-primary block mt-2 mb-1">
                                        Action:
                                      </span>
                                      <EditOutlined
                                        onClick={() => setIsEditing(true)}
                                        className="cursor-pointer text-black text-[18px]"
                                      />
                                    </div>
                  </td>
                </tr>
              ) : (
                <tr>
                  <td className="text-center py-6">
                    <Button type="dashed" onClick={() => setIsEditing(true)}>
                      Add data
                    </Button>
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          <div className="bg-[#F9F9F9] border-b border-[#e9e8e8] rounded-lg sm:hidden block">
            <div className="py-3 px-4">
              <Form layout="vertical" form={form}>
                <Form.Item
                  label="Select Blogs"
                  name={["green_journal", "selectedBlog"]}
                >
                  <Select
                    mode="multiple"
                    placeholder="Select Blogs"
                    className="w-full"
                    showSearch
                    optionFilterProp="label"
                    options={blogList?.map((blog) => ({
                      label: blog.heading,
                      value: blog._id,
                    }))}
                  />
                </Form.Item>
              </Form>

              <ButtonWrapper
                type="primary"
                onClick={handleSave}
                loading={loading}
              >
                Save
              </ButtonWrapper>
            </div>
          </div>
        </>
      ) : (
        <div>
          <div className="bg-[#F9F9F9] p-4 rounded-lg shadow-sm">
            <Form layout="vertical" form={form}>
              <Form.Item
                label="Heading"
                name={["green_journal", "heading"]}
                rules={[{ required: true, message: "Please enter heading" }]}
              >
                <Input placeholder="Heading" />
              </Form.Item>

              <Form.Item
                label="Subtext"
                name={["green_journal", "subtext"]}
                rules={[{ required: true, message: "Please enter subtext" }]}
              >
                <TextArea placeholder="Subtext" rows={2} />
              </Form.Item>
            </Form>
          </div>

          <div className="flex gap-3 mt-6">
            <ButtonWrapper
              type="primary"
              onClick={handleSave}
              loading={loading}
            >
              Save
            </ButtonWrapper>
            <ButtonWrapper onClick={handleCancel}>Cancel</ButtonWrapper>
          </div>
        </div>
      )}
    </div>
  );
};

export default GreenJournal;
